var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-icon",class:{ opended: _vm.value, ..._vm.classNames },on:{"click":_vm.onClick}},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }